(() => {
  const hoverInput = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

  function init(root = document) {
    root.querySelectorAll('.np-about-toggle').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      const item = button.closest('.np-about-dropdown');
      const setOpen = open => {
        item.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', String(open));
        if (!open) item.dataset.npAboutClickOpen = 'false';
      };
      button.addEventListener('click', () => {
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        if (isOpen && item.dataset.npAboutClickOpen === 'true') {
          setOpen(false);
          return;
        }
        item.dataset.npAboutClickOpen = 'true';
        setOpen(true);
      });
      item.addEventListener('pointerenter', event => {
        if (hoverInput.matches && event.pointerType !== 'touch') setOpen(true);
      });
      item.addEventListener('pointerleave', () => {
        if (hoverInput.matches && !item.contains(document.activeElement)) setOpen(false);
      });
      item.addEventListener('focusin', () => setOpen(true));
      item.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' && event.target === button) {
          event.preventDefault();
          setOpen(true);
          item.querySelector('.site-nav__dropdown a')?.focus();
        }
        if (event.key === 'Escape') {
          setOpen(false);
          button.blur();
        }
      });
      item.addEventListener('focusout', () => {
        setTimeout(() => {
          if (!item.contains(document.activeElement)) setOpen(false);
        }, 0);
      });
      document.addEventListener('click', event => {
        if (!item.contains(event.target)) setOpen(false);
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

(() => {
  const gallery = document.querySelector('#productMediaDesktop .thumbnail-media--main-media');
  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const imageSelector = '.swiper-slide img.media-ratio--original:not(.product-medias__thumbnail__image)';
  const zoomScale = 2.1;
  const geometryByImage = new WeakMap();
  let activeSlide = null;

  if (!gallery || !desktopHover.matches) return;

  const resetSlide = (slide) => {
    if (!slide) return;
    slide.classList.remove('npw-product-zoom-active');
    slide.querySelectorAll(imageSelector).forEach((image) => {
      image.style.removeProperty('--npw-zoom-x');
      image.style.removeProperty('--npw-zoom-y');
      geometryByImage.delete(image);
    });
    if (activeSlide === slide) activeSlide = null;
  };

  gallery.addEventListener('pointermove', (event) => {
    if (event.pointerType === 'touch' || !desktopHover.matches) return;

    const image = event.target.closest?.(imageSelector);
    const slide = image?.closest('.swiper-slide');
    if (!image || !slide || !gallery.contains(slide)) return;

    if (activeSlide && activeSlide !== slide) resetSlide(activeSlide);

    let geometry = geometryByImage.get(image);
    if (!geometry) {
      const rect = image.getBoundingClientRect();
      const width = image.offsetWidth;
      const height = image.offsetHeight;
      const baseScale = Number.parseFloat(getComputedStyle(image).getPropertyValue('--np-product-base-scale')) || 1.25;
      if (!width || !height) return;

      geometry = {
        width,
        height,
        baseScale,
        layoutLeft: rect.left - (width / 2) * (1 - baseScale),
        layoutTop: rect.top - (height / 2) * (1 - baseScale),
      };
      geometryByImage.set(image, geometry);
    }

    const { width, height, baseScale, layoutLeft, layoutTop } = geometry;
    const localX = Math.min(width, Math.max(0, (event.clientX - layoutLeft - (width / 2) * (1 - baseScale)) / baseScale));
    const localY = Math.min(height, Math.max(0, (event.clientY - layoutTop - (height / 2) * (1 - baseScale)) / baseScale));
    const translateX = event.clientX - layoutLeft - localX * zoomScale;
    const translateY = event.clientY - layoutTop - localY * zoomScale;

    image.style.setProperty('--npw-zoom-x', `${translateX}px`);
    image.style.setProperty('--npw-zoom-y', `${translateY}px`);
    slide.classList.add('npw-product-zoom-active');
    activeSlide = slide;
  }, { passive: true });

  gallery.addEventListener('pointerout', (event) => {
    const image = event.target.closest?.(imageSelector);
    if (!image || (event.relatedTarget && image.contains(event.relatedTarget))) return;
    resetSlide(image.closest('.swiper-slide'));
  });

  window.addEventListener('blur', () => resetSlide(activeSlide));
  desktopHover.addEventListener?.('change', (event) => {
    if (!event.matches) resetSlide(activeSlide);
  });
})();

(() => {
  if (!window.location.pathname.endsWith('/pages/contacto-mayorista')) return;

  const formSelector = '.klaviyo-form-RnMbzL';
  const originalOption = '$120.000 a $300.000';
  const updatedOption = '$120.000 +IVA a $300.000';

  const updateOption = (form) => {
    form.querySelectorAll('label').forEach((label) => {
      const text = [...label.querySelectorAll('div')].find((element) =>
        element.childElementCount === 0 && element.textContent.trim() === originalOption
      );
      if (!text) return;

      text.textContent = updatedOption;
      const input = document.getElementById(label.htmlFor);
      if (input?.getAttribute('aria-label') === originalOption) {
        input.setAttribute('aria-label', updatedOption);
      }
    });
  };

  const watchForm = (form) => {
    updateOption(form);
    const observer = new MutationObserver(() => updateOption(form));
    observer.observe(form, { childList: true, subtree: true, characterData: true });
  };

  const existingForm = document.querySelector(formSelector);
  if (existingForm) {
    watchForm(existingForm);
    return;
  }

  const rootObserver = new MutationObserver(() => {
    const form = document.querySelector(formSelector);
    if (!form) return;
    rootObserver.disconnect();
    watchForm(form);
  });
  rootObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

(() => {
  const toggleSelector = '[data-np-products-menu-toggle]';
  const hoverInput = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

  const init = (root = document) => {
    root.querySelectorAll(toggleSelector).forEach((button) => {
      if (button.dataset.npMenuInitialized === 'true') return;
      button.dataset.npMenuInitialized = 'true';

      const item = button.closest('.np-products-menu-item');
      if (!item) return;

      const setOpen = (open) => {
        item.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', String(open));
        if (!open) item.dataset.npMenuClickOpen = 'false';
      };

      button.addEventListener('click', () => {
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        if (isOpen && item.dataset.npMenuClickOpen === 'true') {
          setOpen(false);
          return;
        }
        item.dataset.npMenuClickOpen = 'true';
        setOpen(true);
      });

      item.addEventListener('pointerenter', (event) => {
        if (hoverInput.matches && event.pointerType !== 'touch') setOpen(true);
      });

      item.addEventListener('pointerleave', () => {
        if (hoverInput.matches && !item.contains(document.activeElement)) setOpen(false);
      });

      item.addEventListener('focusin', () => setOpen(true));
      item.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!item.contains(document.activeElement)) setOpen(false);
        }, 0);
      });

      item.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' && event.target === button) {
          event.preventDefault();
          setOpen(true);
          item.querySelector('.np-products-dropdown a')?.focus();
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          setOpen(false);
          button.focus();
        }
      });
    });
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  if (!window.__npProductsMenuOutsideClickBound) {
    window.__npProductsMenuOutsideClickBound = true;
    document.addEventListener('click', (event) => {
      document.querySelectorAll(toggleSelector).forEach((button) => {
        const item = button.closest('.np-products-menu-item');
        if (!item || item.contains(event.target)) return;
        item.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        item.dataset.npMenuClickOpen = 'false';
      });
    });
  }
})();
